import { faker } from '@faker-js/faker';

import {
  type DepartmentDetails,
  type PatientData,
  SENSOR_STATUS,
  type SensorState,
  type SensorStatus,
} from '~/api/types';

import { AddressFactory } from './address';
import { alertSettingsFactory } from './alertSettings';

export const patientFactory = ({
  departmentDetails,
}: {
  departmentDetails: DepartmentDetails[];
}): PatientData => {
  const randomStatus: SensorStatus = faker.helpers.arrayElement(
    Object.values(SENSOR_STATUS),
  );

  const statusesWithTimestamp: SensorStatus[] = [
    SENSOR_STATUS.ActiveEndingSoon,
    SENSOR_STATUS.ActiveNoData,
    SENSOR_STATUS.ActiveWarmingUp,
    SENSOR_STATUS.InactiveSensorEnded,
    SENSOR_STATUS.InactiveLastData,
  ];

  const sensorState: SensorState = {
    status: randomStatus,
    ...(statusesWithTimestamp.includes(randomStatus)
      ? { timestamp: faker.date.recent({ days: 30 }).toISOString() }
      : {}),
  };

  const departments = faker.helpers.arrayElements(departmentDetails, 2);
  const idn = faker.helpers.arrayElement(departments).idn;

  return {
    id: faker.string.uuid(),
    address: AddressFactory(),
    lastName: faker.person.lastName(),
    firstName: faker.person.firstName(),
    phoneNumberLast4Digits: faker.number
      .int({ min: 1111, max: 9999 })
      .toString(),
    dateOfBirth: faker.date
      .birthdate({ mode: 'age', min: 20, max: 90 })
      .toISOString(),
    archivedAt: faker.datatype.boolean()
      ? faker.date.past({ years: 1 }).toISOString()
      : undefined,
    departments,
    alertsLast24hours: faker.datatype.boolean()
      ? faker.number.int({ min: 0, max: 3 })
      : null,
    alertState:
      faker.number.int({ min: 1, max: 10 }) === 1 ? 'muted' : undefined,
    status: sensorState,
    lactate: faker.number.float({ min: 0, max: 5, fractionDigits: 1 }),
    createdAt: faker.date.recent({ days: 60 }).toISOString(),
    idn,
    mrn: faker.string.alphanumeric({ length: 10 }).toUpperCase(),
    email: faker.internet.email(),
    phone: faker.phone.number({ style: 'national' }),
    alertsSettings: alertSettingsFactory({}),
  };
};
